module.exports = __webpack_public_path__ + "img/bg_c.66a58e3c.png";